import React, { useRef, useEffect, useState } from "react";
import ForceGraph3D from "react-force-graph-3d";
import { Sprite, TextureLoader, SpriteMaterial } from "three";
import CircularIndeterminate from "../../../../../components/circularProgress";
import API from "../../../../../api";



const getColorBasedOnCount = (count) => {
    const logCount = Math.log10(count + 1); 
    const normalizedCount = logCount / Math.log10(10000); 
    
    const r = Math.floor(255 * (1 - normalizedCount));
    const g = Math.floor(255 * normalizedCount);
    const b = 0; 

    // Restituisci il colore in formato RGB senza trasparenza
    return `rgb(${r},${g},${b})`;
};


const NetworkMapping = ({dialog = false, setQueryType, setOpenDialog, detailMap }) => {

    const [graphData, setGraphData] = useState([])
    const [charged, setCharged] = useState(false)
    const [data, setData] = useState({ nodes: [], links: [] });
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const divRef = useRef(null);
    const fgRef = useRef();

    useEffect(() => {
        API.getTiresia({ mapping: true, dettaglio: detailMap }).then(res => {
            setGraphData(res.data)
            setCharged(true)
        }).catch(err => {
            console.error(err)
            setCharged(true)
        })
    }, [detailMap])

    useEffect(() => {


        const nodes = [];
        const links = [];

        // Mappatura per tenere traccia dei nodi unici
        const nodeMap = {};

        graphData.forEach((item) => {
            const ip1 = item._id.ip1;
            const ip2 = item._id.ip2;
            const count = item.count;

            // Aggiungi i nodi ip1 e ip2 se non esistono già
            if (!nodeMap[ip1]) {
                nodes.push({ id: ip1, color: "#68BBBC", img: "pc-giallo.png", size: 10 });
                nodeMap[ip1] = true;
            }
            if (!nodeMap[ip2]) {
                nodes.push({ id: ip2, color: "#68BBBC", img: "pc-aquamarine.png", size: 10 });
                nodeMap[ip2] = true;
            }

            const particles = Math.min(10, Math.floor(count / 2));
            const color = getColorBasedOnCount(count);

            // Crea un link tra ip1 e ip2 con la pesantezza basata su count
            links.push({
                source: ip1,
                target: ip2,
                color: color,
                label: "Total Count: " + count,
                width: 2,
                particles: particles
              });
        });

        const transformedData = { nodes, links };
        setData(transformedData);
    }, [graphData]);

    useEffect(() => {
        const updateDimensions = () => {
            if (divRef.current) {
                setDimensions({
                    width: divRef.current.offsetWidth,
                    height: divRef.current.offsetHeight,
                });
            }
        };
        window.addEventListener("resize", updateDimensions);
        updateDimensions();
    }, []);

    const getSpriteNode = (node) => {
        const imgTexture = new TextureLoader().load(
          `${process.env.PUBLIC_URL}/${node.img}`
        );
        const material = new SpriteMaterial({ map: imgTexture });
        const sprite = new Sprite(material);
        sprite.scale.set(node.size, node.size, 1); // Usa la dimensione fissa per i nodi
        return sprite;
      };


    if (data === null) {
        return <div>Loading...</div>;
    }

    return (
        <div ref={divRef} style={{ width: "100%", height: (dialog ? "100%" : "30vh")}} id="divFG">
            {data.nodes && data.nodes.length > 0 ? (
                <ForceGraph3D
                    ref={fgRef}
                    graphData={data}
                    height={dimensions.height}
                    draggable={true}
                    width={dimensions.width}
                    backgroundColor="black"
                    nodeLabel={(node) => `IP: ${node.id}`}
                    nodeColor={(node) => node.color}
                    nodeThreeObject={getSpriteNode}
                    linkLabel={(link) => link.label}
                    linkWidth={(link) => link.width}
                    linkDirectionalParticles={(link) => link.particles} 
                    linkDirectionalParticleWidth={0.4}
                    onLinkClick={(e) => {setQueryType({filtered: {ip1: e.source.id, ip2: e.target.id}}); if(dialog){setOpenDialog(false)}}}
                />
            ) : (
                <CircularIndeterminate charged={charged} title="No Data" />
            )}
        </div>
    );
};

export default NetworkMapping;
